import {
    Container,
    Flex,
    Box,
    Heading,
    Text,
    IconButton,
    Button,
    VStack,
    HStack,
    Wrap,
    WrapItem,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputLeftElement,
    Textarea,
    Link,
  } from '@chakra-ui/react';
  import {
    MdPhone,
    MdEmail,
    MdLocationOn,
    MdOutlineEmail,
  } from 'react-icons/md';
  import { BsGithub, BsPerson, BsLinkedin, BsTwitter } from 'react-icons/bs';
  import React, { useRef, useState } from 'react';
  import emailjs from '@emailjs/browser';
  
  export default function Contact() {
    const [loading,setLoading]=useState(false)
    const form = useRef();
    
      const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);
        emailjs.sendForm('service_si0x9ck', 'template_yw3yo16', form.current, '_Bq8dUX2pKerRmc1d')
          .then((result) => {
            setLoading(false);
            alert("Message sent")
              console.log(result.text);
          }, (error) => {
            setLoading(false);
            alert("somthing went wrong")
              console.log(error.text);
          });
      };

    return (
      <Container  maxW="full" mt={0} centerContent overflow="hidden" id='contact'>
        <Flex>
          <Box
            bg="teal"
            color="white"
            borderRadius="lg"
            m={{ sm: 4, md: 16, lg: 10 }}
            p={{ sm: 5, md: 5, lg: 16 }}>
            <Box p={4}>
              <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
                <WrapItem>
                  <Box>
                    <Heading fontSize={{base:"2xl",lg:"4xl"}}>Contact</Heading>
                    <Text mt={{ sm: 3, md: 3, lg: 5 }} color="white">
                      Fill up the form to contact
                    </Text>
                    <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                      <VStack pl={0} spacing={3} alignItems={'left'} justifyContent={'left'}>
                        <Button
                          size="md"
                          height="48px"
                          width="200px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdPhone color="#1970F1" size="20px" />}>
                          +91-7488064448
                        </Button>
                        <Link href="mailto:avi064448@gmail.com" target="_blank">
                        <Button
                          size="md"
                          height="48px"
                          width="200px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdEmail color="#1970F1" size="20px" />}>
                          avi064448@gmail.com
                        </Button>
                        </Link>
                        <Link href='https://goo.gl/maps/E93PSgogxjcZ8pXj7' target={"_blank"}><Button
                          size="md"
                          height="48px"
                          width="200px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdLocationOn color="#1970F1" size="20px" />}>
                          Munger, Bihar, India
                        </Button>
                        </Link>
                      </VStack>
                    </Box>
                    <HStack
                      mt={{ lg: 10, md: 10 }}
                      spacing={5}
                      px={5}
                      alignItems="flex-start">
                     <Link href='https://www.linkedin.com/in/avinash-kumar-b1005b230/' target={"_blank"}> <IconButton
                        aria-label="linkedin"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<BsLinkedin size="28px" />}
                      />
                      </Link>
                      <Link href='https://twitter.com/AVINASH67568935' target={"_blank"}><IconButton
                        aria-label="twitter"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<BsTwitter size="28px" />}
                      />
                      </Link>

                     <Link href='https://github.com/avinash7488' target={"_blank"}> <IconButton
                        aria-label="github"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<BsGithub size="28px" />}
                      />
                      </Link>
                    </HStack>
                  </Box>
                </WrapItem>

                <WrapItem>
                  <Box bg="white" borderRadius="lg">
                    <Box m={8} color="#0B0E3F">
                        <form ref={form} onSubmit={sendEmail}>
                      <VStack spacing={5}>
                        <FormControl >
                          <FormLabel>Your Name</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<BsPerson color="gray.800" />}
                            />
                            <Input type="text" name="user_name" size="md" />
                          </InputGroup>
                        </FormControl>
                        <FormControl >
                          <FormLabel>Your Email</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<MdOutlineEmail color="gray.800" />}
                            />
                            <Input type="email" name="user_email" size="md" />
                          </InputGroup>
                        </FormControl>
                        <FormControl >
                          <FormLabel>Message</FormLabel>
                          <Textarea name="message"
                            borderColor="gray.300"
                            _hover={{
                              borderRadius: 'gray.300',
                            }}
                            placeholder="message"
                          />
                        </FormControl>
                        <FormControl id="button" float="right">
                           {loading?<Button
                                isLoading="false"
                                loadingText='Sending'
                                colorScheme='teal'
                                variant='outline'
                            >
                             Submit
                          </Button>
                          :
                          <Button type="submit" value="Send"
                            variant="solid"
                            bg="teal"
                            color="white"
                            _hover={{}}>
                            Send Message
                        </Button>
                        } 
                          
                        </FormControl>
                      </VStack>
                      </form>
                    </Box>
                  </Box>
                </WrapItem>
              </Wrap>
            </Box>
          </Box>
        </Flex>
      </Container>
    );
  }